export default __webpack_public_path__ + "a9f88a4ccd2fb9c39e8fb12cecd7a521.png";